import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { RecommendationProduct } from '@/checkout-instore-legacy/product/typings'
import {
  ProductCarouselImage,
  ProductCarouselItem,
  ProductCarouselItemTitle,
} from '@/checkout-instore-legacy/components/ProductCarousel'

export type RecommendationProductsItemProps = {
  product: RecommendationProduct
  handleProductClick: () => void
}

export const RecommendationProductsItem = ({
  product,
  handleProductClick,
}: RecommendationProductsItemProps) => (
  <ProductCarouselItem onClick={handleProductClick}>
    <ProductCarouselImage
      src={product.imageUrl}
      alt={product.name}
      sizeInPx={300}
    />
    <ProductCarouselItemTitle>{product.name}</ProductCarouselItemTitle>
    {/* TODO: use ProductPrice when get price from simulation */}
    <div
      className={csx({
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginTop: '$space-1',
        '@desktop': {
          marginTop: '$space-3',
        },
      })}
    >
      <Text variant="action2" tone="secondary">
        {/* // TODO: this error popped up when moving the checkout-instore project
        // to checkout-instore-legacy, but needs to be fixed at some point
        // @ts-ignore */}
        <Price className="b" value={product.price} />
      </Text>
      {product.listPrice > product.price && (
        <Text variant="detail" tone="secondary">
          {/* // TODO: this error popped up when moving the checkout-instore project
          // to checkout-instore-legacy, but needs to be fixed at some point
          // @ts-ignore */}
          <Price className="strike" value={product.listPrice} />
        </Text>
      )}
    </div>
  </ProductCarouselItem>
)
